import { render, staticRenderFns } from "./UspsSetupForm.vue?vue&type=template&id=0a3b3062&"
import script from "./UspsSetupForm.vue?vue&type=script&lang=js&"
export * from "./UspsSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports